<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid content">
          <slot name="header" />
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Администрирование</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content">
          <div class="df-js-b df-al admin-legend--container">
            <div class="breadcrumb-wrapp">
              <a href="/administration/">Администрирование</a> >
              <span v-if="filter.type == 'es'">Чек-лист для экспертного совета</span>
              <span v-else-if="filter.type=='dz'">Чек-лист для подписания договора займа</span>
            </div>
            <div class="admin-legend">
              <div class="col">
                Легенда статусов:<br />
                1. ПКД - Подготовка комплекта документов<br />
                2. КЭ - Комплексная экспертиза<br />
                3. ПкЭС - Подготовка к экспертному совету<br />
                4. ЭС РФРП - Экспертный совет РФРП<br />
                5. Оценка ПСКП - Оценка проекта на<br />
                соответствие критериям программы
              </div>
              <div class="col">
                Легенда программ:<br />
                1. ПР - Проекты развития<br />
                2. Комплект - Комплектующие изделия<br />
                3. ППТ - Производительность труда<br />
                4. ФКиРБ - Формирование компонентной и ресурсной базы<br />
                5. ОМП - Обеспечение мобилизационных потребностей<br />
              </div>
            </div>

          </div>

          <div class="d-flex">
            <div class="wrap stl-df-ac">
              <router-link
                :to="{ name: 'AdminStatuses', params: {'type': filter.type} }"
                class="administration-page_m__item-link"
              >
                Статусы загрузки документов
              </router-link>

              <router-link
                v-if="filter.type == 'es'"
                :to="{ name: 'Acceptance' }"
                class="r-button administration-page_m__item-link"
              >
                Акцептование документов
              </router-link>

              <button
                type="button"
                class="user-info"
                @click="showStatusHistory = true"
                v-if="managerList && managerList.STATUS"
              >
                Последнее изменение:
                {{ managerList.STATUS[0].MANAGER_INFO }} ({{
                  managerList.STATUS[0].DATE_SAVE
                }})
              </button>
            </div>
          </div>
          <div
            class="container-fluid mycontainer-fluid content table-responsive"
            style="padding-left: 0; padding-right: 0;"
          >
            <div class="col-xs-12 mycol">
              <div class="status-filter-container">
                <div class="status-filter-container__form">
                  <!--<div class="status-filter-container__form-item">
                      <label for="sf-all">Всё</label>
                      <input
                        type="radio"
                        name="sf-group"
                        value="all"
                        v-model="filter.type"
                        id="sf-all"
                      />
                    </div>-->
                  <div class="status-filter-container__form-item">
                    <label for="sf-ec">ЭС</label>
                    <input
                      type="radio"
                      name="sf-group"
                      value="es"
                      v-model="filter.type"
                      id="sf-ec"
                      @click="gotoToNewPage('es')"
                    />
                  </div>
                  <div class="status-filter-container__form-item">
                    <label for="sf-dz">ДЗ</label>
                    <input
                      type="radio"
                      name="sf-group"
                      value="dz"
                      v-model="filter.type"
                      id="sf-dz"
                      @click="gotoToNewPage('dz')"
                    />
                  </div>
                  <!--<div class="status-filter-container__form-item">
                    <button
                      @click="fetchList"
                      class="butt-new-style project-filter__butt-btn"
                    >
                      Применить
                    </button>
                  </div>-->
                  <div class="status-filter-container__form-item"
                       v-if="isSaveData"
                       style="background-color: #ffA500; padding: 0 4px;">
                   <img src="/img/waiting.gif" style="width:20px;" /> Идет сохранение данных, не обновляйте страницу
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mycol">
              <table
                class="c-indicator c-indicator-w-100 c-indicator-admin js-table-thead-sticky"
              >
                <thead class="js-thead-sticky">
                <tr>
                  <th>№ п/п</th>
                  <th>Наименование документа</th>
                  <th>Формат</th>
                  <th v-if="filter.type=='es'" class="th-tc">Обязательность</th>
                  <th v-if="filter.type=='es'" >Загружающий</th>
                  <th>Дата начала действия</th>
                  <th>Дата окончания действия</th>
                  <th
                    v-for="program in programList"
                    :key="program.ID"
                    class="cnt th-link"
                  >
                    <router-link
                      :to="{
                          name: 'AdminStatusesColumn',
                          params: { id: program.ID, type: filter.type}
                        }"
                      class="administration-page_m__item-link"
                      :title="program.NAME"
                    >
                      {{ program.SMALL_NAME }}
                    </router-link>
                  </th>
                  <th colspan="2">Комментарии</th>
                </tr>
                </thead>
                <tbody v-if="!isAdminStatusDocsLoading">
                <template v-for="(item, index) in adminStatusDocsItems">
                  <tr :key="getRandomInt() +  `item-${index}`" class="back-jur">
                    <td style="min-width: 60px;">{{ index + 1 }}</td>
                    <td :colspan="((filter.type=='es')?8:6) + programList.length">
                      <b>{{ item.SECTION_NAME }}</b>
                    </td>
                  </tr>
                  <template v-if="item.TYPE_LIST && item.TYPE_LIST.length > 0"
                  >
                    <tr
                      v-for="(type, idx) in item.TYPE_LIST"
                      :key="getRandomInt() + `=${idx}-${type.UF_NAME}-${type.ID}-`"
                    >
                      <td>{{ index + 1 }}.{{ idx + 1 }}</td>
                      <td>
                        <router-link
                          :to="{
                              name: 'InfoDocument',
                              params: { id: type.ID },
                              query: {type: filter.type}
                            }"
                          class="administration-page_m__item-link"
                          v-html="type.UF_NAME"
                        />
                      </td>
                      <td>
                        <template v-if="filter.type=='es'">{{ type.UF_EXT_TEXT }}</template>
                        <template v-else>{{ type.UF_EXT_DZ_TEXT }}</template>
                      </td>
                      <td class="cnt" v-if="filter.type=='es'">
                        <input
                          type="checkbox"
                          v-model="type.UF_IS_REQ"
                          :disabled="!isEdit"
                        />
                      </td>
                      <td v-if="filter.type=='es'">
                        <template v-if="isEdit">
                          <multiselect
                            v-model="type.UF_GROUP_LOAD_USER_ARR"
                            :options="allGroupUserListComp"
                            class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                            :multiple="true"
                            :limit="30"
                            track-by="ID"
                            label="NAME"
                            placeholder
                          >
                            <span slot="noOptions">Группы не найдены</span>
                            <span slot="noResult">Группы не найдены</span>
                          </multiselect>
                        </template>
                        <template v-else>
                          {{
                            getNamesFromGroupLoadUserArr(
                              type.UF_GROUP_LOAD_USER_ARR
                            )
                          }}
                        </template>
                      </td>
                      <td>{{ type.UF_DATE_START }}</td>
                      <td>{{ type.UF_DATE_END }}</td>
                      <!-- Данные по программам -->
                      <template v-for="(program, idx) in programList">
                       <template v-if="filter.type=='es'">
                          <template v-if="isEdit">
                            <td :key="getRandomInt() + `=${idx}-${program.CODE}-${program.NAME}`">
                              {{ type.UF_STATUS_TEXT[idx].SMALL }}
                            </td>
                          </template>
                          <template v-else>
                            <td :key="getRandomInt() + `${idx}-${program.CODE}-${program.NAME}`">
                              {{
                                getStatusText(
                                  type.UF_STATUS_TEXT || [],
                                  program.ID
                                )
                              }}
                            </td>
                          </template>
                       </template>
                        <template v-else>
                          <td class="cnt"
                              :key="getRandomInt() + `${idx}-${program.CODE}-${program.NAME}`">

                            <template v-for="checkDz in type.UF_IS_CHECK_LIST_DZ">
                              <input
                                v-if="checkDz.UF_SUPPORT_PROGRAM_ID == program.ID"
                                type="checkbox"
                                v-model="checkDz.UF_IS_CHECK_LIST"
                                />
                            </template>

                          </td>
                        </template>
                      </template>
                      <td>{{ type.UF_COMMENTS }}</td>
                      <td style="min-width: 30px">
                        <i
                          v-if="isEdit"
                          class="i-edit centerIcon"
                          @click="showComment(type)"
                        ></i>
                      </td>
                    </tr>
                  </template>
                  <template v-if="item.CHILD && item.CHILD.length > 0">
                    <template v-for="(child, idx) in item.CHILD">
                      <tr
                        :key="getRandomInt() + `=${idx}-${child.SECTION_NAME}`"
                        class="back-jur"
                      >
                        <td>{{ index + 1 }}.{{ idx + + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}</td>
                        <td :colspan="((filter.type=='es')?8:6) + programList.length">
                          <b>{{ child.SECTION_NAME }}</b>
                        </td>
                      </tr>
                      <template
                        v-if="child.TYPE_LIST && child.TYPE_LIST.length > 0"
                      >
                        <tr
                          v-for="(type, indx) in child.TYPE_LIST"
                          :key="getRandomInt() + `=${indx}-${type.UF_NAME}-${type.UF_IS_REQ}`"
                        >
                          <td>
                            {{ index + 1 }}.{{ idx + + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}.{{ indx + 1 }}
                          </td>
                          <td>
                            <router-link
                              :to="{
                                  name: 'InfoDocument',
                                  params: { id: type.ID},
                                  query: {type: filter.type}
                                }"
                              class="administration-page_m__item-link"
                              v-html="type.UF_NAME"
                            />
                          </td>
                          <td>
                            <template v-if="filter.type=='es'">{{ type.UF_EXT_TEXT }}</template>
                            <template v-else>{{ type.UF_EXT_DZ_TEXT }}</template>
                          </td>
                          <td class="cnt" v-if="filter.type=='es'">
                            <input
                              type="checkbox"
                              v-model="type.UF_IS_REQ"
                              :disabled="!isEdit"
                            />
                          </td>
                          <td v-if="filter.type=='es'">
                            <template v-if="isEdit">
                              <multiselect
                                v-model="type.UF_GROUP_LOAD_USER_ARR"
                                :options="allGroupUserListComp"
                                class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                                :multiple="true"
                                :limit="30"
                                track-by="ID"
                                label="NAME"
                                placeholder
                              >
                                  <span slot="noOptions"
                                  >Группы не найдены</span
                                  >
                                <span slot="noResult">Группы не найдены</span>
                              </multiselect>
                            </template>
                            <template v-else>
                              {{
                                getNamesFromGroupLoadUserArr(
                                  type.UF_GROUP_LOAD_USER_ARR
                                )
                              }}
                            </template>
                          </td>
                          <td>{{ type.UF_DATE_START }}</td>
                          <td>{{ type.UF_DATE_END }}  </td>
                          <!-- Данные по программам -->
                          <template v-for="(program, idx) in programList">
                            <template v-if="filter.type=='es'">
                              <template v-if="isEdit">
                                <td
                                  :key="
                                     getRandomInt() + `=${idx}-${program.CODE}-${program.NAME}`
                                    "
                                >
                                  {{ type.UF_STATUS_TEXT[idx].SMALL }}
                                </td>
                              </template>
                              <template v-else>
                                <td
                                  :key="
                                    getRandomInt() + `=${idx}-${program.CODE}-${program.NAME}`
                                  "
                                >
                                  {{
                                    getStatusText(
                                      type.UF_STATUS_TEXT || [],
                                      program.ID
                                    )
                                  }}
                                </td>
                              </template>
                            </template>
                            <template v-else>
                              <td class="cnt"
                                  :key="getRandomInt() +  `=${idx}-${program.CODE}-${program.NAME}`">

                                <template v-for="checkDz in type.UF_IS_CHECK_LIST_DZ">
                                  <input
                                    v-if="checkDz.UF_SUPPORT_PROGRAM_ID == program.ID"
                                    type="checkbox"
                                    v-model="checkDz.UF_IS_CHECK_LIST"
                                  />
                                </template>

                              </td>
                            </template>
                          </template>
                          <td>{{ type.UF_COMMENTS }}</td>
                          <td style="min-width: 30px;">
                            <i
                              v-if="isEdit"
                              class="i-edit centerIcon"
                              @click="showComment(type)"
                            ></i>
                          </td>
                        </tr>
                      </template>

                      <!-- 2 уровень --->
                      <template v-for="(child2, idx2) in child.CHILD">
                        <tr
                          :key="getRandomInt() + `=${idx2}-${child2.SECTION_NAME}`"
                          class="back-jur"
                        >
                          <td>{{ index + 1 }}.{{ idx + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}.{{idx2+1}}</td>
                          <td :colspan="((filter.type=='es')?8:6) + programList.length">
                            <b>{{ child2.SECTION_NAME }}</b>
                          </td>
                        </tr>

                        <template
                          v-if="child2.TYPE_LIST && child2.TYPE_LIST.length > 0"
                        >
                          <tr
                            v-for="(type2, indx2) in child2.TYPE_LIST"
                            :key="getRandomInt() + `=${indx2}-${type2.UF_NAME}-${type2.UF_IS_REQ}`"
                          >
                            <td>
                              {{ index + 1 }}.{{ idx + + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}.{{ idx2 + 1 }}.{{ indx2 + 1 }}
                            </td>

                            <td>
                              <router-link
                                :to="{
                                  name: 'InfoDocument',
                                  params: { id: type2.ID},
                                  query: {type: filter.type}
                                }"
                                class="administration-page_m__item-link"
                                v-html="type2.UF_NAME"
                              />
                            </td>
                            <td>
                              <template v-if="filter.type=='es'">{{ type2.UF_EXT_TEXT }}</template>
                              <template v-else>{{ type2.UF_EXT_DZ_TEXT }}</template>
                            </td>
                            <td class="cnt" v-if="filter.type=='es'">
                              <input
                                type="checkbox"
                                v-model="type2.UF_IS_REQ"
                                :disabled="!isEdit"
                              />
                            </td>
                            <td v-if="filter.type=='es'">
                              <template v-if="isEdit">
                                <multiselect
                                  v-model="type2.UF_GROUP_LOAD_USER_ARR"
                                  :options="allGroupUserListComp"
                                  class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                                  :multiple="true"
                                  :limit="30"
                                  track-by="ID"
                                  label="NAME"
                                  placeholder
                                >
                                  <span slot="noOptions"
                                  >Группы не найдены</span
                                  >
                                  <span slot="noResult">Группы не найдены</span>
                                </multiselect>
                              </template>
                              <template v-else>
                                {{
                                  getNamesFromGroupLoadUserArr(
                                    type2.UF_GROUP_LOAD_USER_ARR
                                  )
                                }}
                              </template>
                            </td>
                            <td>{{ type2.UF_DATE_START }}</td>
                            <td>{{ type2.UF_DATE_END }}  </td>
                            <!-- Данные по программам -->

                            <template v-for="(program, idxPrg) in programList">
                              <template v-if="filter.type=='es'">
                                <template v-if="isEdit">
                                  <td
                                    :key="
                                     getRandomInt() +  `=${idxPrg}-${program.CODE}-${program.NAME}`
                                    "
                                  >
                                    {{ type2.UF_STATUS_TEXT[idxPrg].SMALL }}
                                  </td>
                                </template>
                                <template v-else>
                                  <td
                                    :key="
                                    getRandomInt() + `=${idxPrg}-${program.CODE}-${program.NAME}`
                                  "
                                  >
                                    {{
                                      getStatusText(
                                        type2.UF_STATUS_TEXT || [],
                                        program.ID
                                      )
                                    }}
                                  </td>
                                </template>
                              </template>
                              <template v-else>
                                <td class="cnt"
                                    :key="getRandomInt() +  `=${idx}-${program.CODE}-${program.NAME}`">

                                  <template v-for="checkDz in type.UF_IS_CHECK_LIST_DZ">
                                    <input
                                      v-if="checkDz.UF_SUPPORT_PROGRAM_ID == program.ID"
                                      type="checkbox"
                                      v-model="checkDz.UF_IS_CHECK_LIST"
                                    />
                                  </template>

                                </td>
                              </template>
                            </template>

                            <td>{{ type2.UF_COMMENTS }}</td>
                            <td style="min-width: 30px;">
                              <i
                                v-if="isEdit"
                                class="i-edit centerIcon"
                                @click="showComment(type2)"
                              ></i>
                            </td>
                          </tr>
                        </template>

                      </template>
                      <!-- 2 уровень --->
                    </template>
                  </template>
                </template>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="8">Загрузка данных...</td>
                </tr>
                </tbody>
              </table>
            </div>


            <!-- /.modal new documents -->
            <div
              class="modal fade in"
              v-bind:class="{ show: showCreateNewQuestion }"
              tabindex="-1"
              role="dialog"
            >
              <form v-on:submit.prevent="onAddNewDoc">
                <div class="modal-dialog modal-dialog-datepicker-right modal-close-active modal-new-style"
                     role="document">
                  <div class="modal-content add-new-type-document-check-list">
                    <div class="modal-header">
                      <button
                        type="button"
                        class="close"
                        v-on:click="showCreateNewQuestion = false"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4 class="modal-title">Добавление нового документа</h4>
                    </div>
                    <div class="modal-body">
                      <div
                        class="alert alert-danger"
                        v-show="addError !== ''"
                        role="alert"
                      >
                        {{ addError }}
                      </div>

                      <div
                        class="form-group"
                        v-bind:class="{'has-error': checkErrorField('UF_NAME')}"
                      >
                        <label>Наименование документа<sup style="color: red">*</sup></label>
                        <textarea
                          class="form-control i-main-style"
                          v-model="newDocType.UF_NAME"
                          @keyup="removeError('UF_NAME')"
                          style="resize: vertical;"
                        ></textarea>
                      </div>
                      <div
                        class="form-group"
                      >
                        <div class="controller stl-controller-wrapper">
                          <label>Дата начала действия документа</label>
                          <datepicker
                            v-model="newDocType.UF_DATE_START"
                            :language="ru"
                            input-class="form-control filter-input-datapicer form-control-data-inp_"
                            placeholder="Укажите дату начала действия документа"
                            :monday-first="true"
                          />
                          <template v-if="newDocType.UF_DATE_START">
                            <i
                              @click="newDocType.UF_DATE_START = ''"
                              class="icon-item icon-delete-link"
                              style="float: right; margin-top:12px; margin-right: 0px;"
                            ></i>
                          </template>
                        </div>
                      </div>
                      <div
                        class="form-group"
                      >
                        <div class="controller stl-controller-wrapper">
                          <label>Раздел документа ЭС</label>
                          <Multiselect
                            label="NAME"
                            class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                            :limit="30"
                            track-by="SECTION_ID"
                            v-model="newDocType.UF_RAZDEL_ES_ID"
                            :options="allRazdelEs()"
                            :multiple="false"
                            placeholder="Выберите раздел документа ЭС"
                            style="min-height: 42px; height: auto;"
                          >
                            <span slot="noOptions">Список разделов не найден</span>
                            <span slot="noResult">Список разделов не найден</span>
                          </Multiselect>
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-if="newDocType.UF_RAZDEL_ES_ID && newDocType.UF_RAZDEL_ES_ID.SECTION_ID > 0"
                      >
                        <div class="controller stl-controller-wrapper">
                          <label>Обязательность документа в ЭС</label>
                          <div>
                            <select
                              class="sel-dropdown form-control"
                              v-model="newDocType.UF_IS_REQ"
                            >
                              <option :value="1">Да</option>
                              <option :value="0">Нет</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-if="newDocType.UF_RAZDEL_ES_ID && newDocType.UF_RAZDEL_ES_ID.SECTION_ID > 0"
                        v-bind:class="{'has-error': checkErrorField('UF_RAZDEL_ES_FOLDER')}"
                      >
                        <div class="controller stl-controller-wrapper">
                          <label>Папка выгрузки для  документа ЭС<sup style="color: red">*</sup></label>
                          <Multiselect
                            label="NAME"
                            class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                            :limit="30"
                            track-by="ID"
                            v-model="newDocType.UF_RAZDEL_ES_FOLDER"
                            :options="listFolderES"
                            :multiple="false"
                            placeholder="Выберите папку для выгрузки документа ЭС"
                            style="min-height: 26px;"
                            @input="removeError('UF_RAZDEL_ES_FOLDER')"
                          >
                            <span slot="noOptions">Список папок не найден</span>
                            <span slot="noResult">Список папок не найден</span>
                          </Multiselect>
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-bind:class="{'has-error': checkErrorField('UF_EXT_ARR')}"
                        v-if="newDocType.UF_RAZDEL_ES_ID && newDocType.UF_RAZDEL_ES_ID.SECTION_ID > 0">
                        <label>Допустимые расширения файлов (ЭС)<sup style="color: red">*</sup></label>
                        <Multiselect
                          label="NAME"
                          class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                           :limit="30"
                          track-by="ID"
                          v-model="newDocType.UF_EXT_ARR"
                          :options="allExtList"
                          :multiple="true"
                          placeholder="Укажите расширения документа"
                          style="min-height: 42px; height: auto"
                          @input="removeError('UF_EXT_ARR')"
                        >
                          <span slot="noOptions">Список расширений не найден</span>
                          <span slot="noResult">Список расширений не найден</span>
                        </Multiselect>
                      </div>
                      <div
                        class="form-group"
                        v-bind:class="{'has-error': checkErrorField('UF_GROUP_LOAD_USER_ARR')}"
                        v-if="newDocType.UF_RAZDEL_ES_ID && newDocType.UF_RAZDEL_ES_ID.SECTION_ID > 0">
                        <label>Загружающий (ЭС)<sup style="color: red">*</sup></label>
                        <Multiselect
                          label="NAME"
                          class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                          :limit="30"
                          track-by="ID"
                          v-model="newDocType.UF_GROUP_LOAD_USER_ARR"
                          :options="allGroupUserListComp"
                          :multiple="true"
                          placeholder="Укажите роль (роли) загружающего ЭС"
                          style="min-height: 42px; height: auto"
                          @input="removeError('UF_GROUP_LOAD_USER_ARR')"
                        >
                          <span slot="noOptions">Пользователи не найдены</span>
                          <span slot="noResult">Пользователи не найдены</span>
                        </Multiselect>
                      </div>
                      <div
                        class="form-group"
                        v-bind:class="{'has-error': checkErrorField('UF_RAZDEL_ES_SMALL_NAME')}"
                        v-if="newDocType.UF_RAZDEL_ES_ID && newDocType.UF_RAZDEL_ES_ID.SECTION_ID > 0"
                      >
                        <label>Укажите краткое наименование файла при загрузке на сервер<sup style="color: red">*</sup><br/>
                        (например: "ЭкономическоеОбоснованиеПроекта", "БизнесПлан", "Резюме" и т.д.)</label>
                        <input
                          class="form-control i-main-style"
                          v-model="newDocType.UF_RAZDEL_ES_SMALL_NAME"
                          style="resize: vertical;"
                          @keyup="removeError('UF_RAZDEL_ES_SMALL_NAME')"
                        />
                      </div>
                      <div
                        class="form-group"
                      >
                        <div class="controller stl-controller-wrapper">
                          <label>Раздел документа ДЗ</label>
                          <Multiselect
                            label="NAME"
                            class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                            :limit="1"
                            track-by="SECTION_ID"
                            v-model="newDocType.UF_RAZDEL_DZ_ID"
                            :options="allRazdelDz()"
                            :multiple="false"
                            placeholder="Выберите раздел документа ДЗ"
                            style="min-height: 42px; height: auto"
                          >
                            <span slot="noOptions">Список разделов не найден</span>
                            <span slot="noResult">Список разделов не найден</span>
                          </Multiselect>
                        </div>
                      </div>
                      <div class="form-group"
                           v-bind:class="{'has-error': checkErrorField('UF_EXT_DZ_ARR')}"
                           v-if="newDocType.UF_RAZDEL_DZ_ID && newDocType.UF_RAZDEL_DZ_ID.SECTION_ID > 0">
                        <label>Допустимые расширения файлов для подписания (ДЗ)<sup style="color: red">*</sup></label>
                        <Multiselect
                          label="NAME"
                          class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                          :limit="30"
                          track-by="ID"
                          v-model="newDocType.UF_EXT_DZ_ARR"
                          :options="allExtList"
                          :multiple="true"
                          placeholder="Укажите расширения документа"
                          style="min-height: 42px; height: auto"
                          @input="removeError('UF_EXT_DZ_ARR')"
                        >
                          <span slot="noOptions">Список расширений не найден</span>
                          <span slot="noResult">Список расширений не найден</span>
                        </Multiselect>
                      </div>
                      <div class="form-group"
                           v-if="newDocType.UF_RAZDEL_DZ_ID && newDocType.UF_RAZDEL_DZ_ID.SECTION_ID  > 0">
                        <label>Вид документа на подписании (ДЗ)</label>
                        <Multiselect
                          label="NAME"
                          class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                          :limit="30"
                          track-by="ID"
                          v-model="newDocType.UF_VID_DOC_DZ_ARR"
                          :options="allVidDocDZ"
                          :multiple="true"
                          placeholder="Укажите виды документа ДЗ"
                          style="min-height: 42px; height: auto;"
                        >
                          <span slot="noOptions">Виды не найдены</span>
                          <span slot="noResult">Виды не найдены</span>
                        </Multiselect>
                      </div>


                      <div
                        class="form-group"
                      >
                        <label>Сортировка</label>
                        <input
                          v-model="newDocType.UF_SORT"
                          @keypress="isNumber($event)"
                          type="text"
                          class="form-control"

                        />
                      </div>

                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        v-on:click="clearForm()"
                      >
                        Отмена
                      </button>
                      <button type="submit" class="btn btn-primary">
                        Добавить
                      </button>
                    </div>
                  </div>
                  <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
              </form>
            </div>
            <!-- /.modal -->

          </div>
        </div>
      </div>
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div v-if="isEdit" class="footer-sabmit" style="padding-right: 122px;">
          <button
            @click="fetchList"
            class="but-style but-ext screenplay-container"
            style="height: 30px;"
          >
            Отмена
          </button>

          <button
            @click="saveStatuses"
            style="height: 30px;"
            class="but-style but-save screenplay-container"
          >
            Сохранить
          </button>

          <button
            style="float:right; width:210px; height: 30px;"
            class="but-style but-save screenplay-container"
            @click="showCreateNewQuestion = true"
          >Добавить новый документ
          </button
          >
        </div>


        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>

    <div
      class="modal fade in show"
      v-if="showStatusHistory"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div
          class="modal-dialog modal-close-active modal-new-style"
          role="document"
        >
          <div class="modal-content modal-content-middle modal-content-history">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showStatusHistory = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">История сохранений</h4>
            </div>
            <div class="modal-body">
              <div
                class="modal-history-statys"
                v-for="(item, index) in managerList.STATUS"
                :key="index"
              >
                <div class="modal-history-statys__name">
                  {{ item.MANAGER_INFO }} - {{ item.DATE_SAVE }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="butt-stl butt-black"
                @click="showStatusHistory = false"
              >
                закрыть
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->

    <!-- комментарии -->
    <div
      class="modal fade in show"
      v-if="showCommentDialog"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div class="modal-dialog modal-new-style" role="document">
          <div class="modal-content modal-content-middle">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                aria-label="Close"
                style="display: block;"
                @click="showCommentDialog = false"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Комментарии</h4>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label>Тип документа: "{{ commentActual.UF_NAME }}"</label>
                <label>История комментариев:</label>
                <div
                  class="modal-history-statys"
                  v-for="(item, index) in commentListByType[commentActual.ID]"
                  :key="index"
                >
                  <div
                    class="modal-history-statys__name"
                    style="padding:4px 0; font-size:11px; border-bottom: 1px solid #ccc;"
                  >
                    {{ item.MANAGER_INFO }} - {{ item.DATE_SAVE }} <br />
                    <span>{{ item.UF_COMMENTS }}</span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Ввод комментария:</label>
                <textarea
                  class="form-control"
                  v-model="commentActual.UF_COMMENTS"
                  placeholder="Текст комментария"
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="butt-stl butt-black"
                type="button"
                @click="showCommentDialog = false"
              >
                Закрыть
              </button>
              <button
                class="butt-stl butt-blue"
                type="button"
                @click="
                  setCommentAdminType(
                    commentActual.ID,
                    commentActual.UF_COMMENTS
                  )
                "
              >
                Отправить
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->

  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_ADMIN_STATUS_DOCS_LIST,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { AdminService, ExpertAdvice, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import { includes } from "vue2-timepicker";
import Vue from "vue";

export default {
  name: "AdminStatuses",
  title: "Статусы загрузки документов",
  components: { Datepicker, Multiselect },
  data() {
    return {
      siteUrl: "",
      isEdit: false,
      showStatusHistory: false,
      commentActual: [],
      showCommentDialog: false,
      filter: {
        type: (this.$route.params.type && this.$route.params.type !== "") ? this.$route.params.type : "es"
      },
      showCreateNewQuestion: false,
      newDocType: {
        UF_NAME: "",
      },
      addError: "",
      ru: ru,
      saveErrorFields: [],
      isSaveData: false,
    };
  },

  computed: {
    ...mapGetters([
      "adminStatusDocsItems",
      "allGroupUserList",
      "allTypeList",
      "allTypeListDz",
      "allVidDocDZ",
      "allExtList",
      "programList",
      "managerList",
      "listFolderES",
      "commentListByType",
      "statusAcceptancesProgramList",
      "statusLoadProgramList",
      "isAdminStatusDocsLoading"
    ]),
    allGroupUserListComp() {
      return Object.values(this.allGroupUserList) || [];
    },
    listConfig() {
      const q = {
        filter: {}
      };

      if (this.$route.params.type !== "" &&
        (["es", "dz"].includes(this.$route.params.type))) {
        q.filter.type = this.$route.params.type;
      } else {
        q.filter.type = "es";
      }

      /*if (this.filter.type !== "" &&
         (['es', 'dz'].includes(this.filter.type))) {
        q.filter.type = this.filter.type;
      }*/
      return q;
    }
  },

  beforeRouteLeave(to, from, next) {
    this.adminStatusDocsItems = [];
    next();
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.isEdit = data.SETTING_RULES_ADMIN_MODULE.REPORTING_DOCUMENTS_IS_EDIT;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });

    this.fetchList();
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    fetchList() {
      this.$route.params.type = this.filter.type;
      this.$store.dispatch(FETCH_ADMIN_STATUS_DOCS_LIST, this.listConfig);
    },
    getStatusText(statusArr, programId) {
      const statusObj = statusArr.find(
        status => status.ID_PROGRAM === programId
      );
      return statusObj ? statusObj.SMALL : "";
    },
    getNamesFromGroupLoadUserArr(arr) {
      return arr
        .filter(el => !!el)
        .map(u => u.NAME)
        .join(", ");
    },
    saveStatuses() {
      this.isSaveData = true;
      return AdminService.saveListStatusLoadDocuments({
        TYPE_SAVE: "all_status_save",
        fields: this.adminStatusDocsItems
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
            this.fetchList();
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }

          this.isSaveData = false
        }, this)
        .catch(err => {
          console.log(err);
          this.isSaveData = false
        });
    },
    handleScroll() {
      var tableTheadSticky = document.querySelector(
        "table.js-table-thead-sticky"
      );
      var theadSticky = document.querySelector("thead.js-thead-sticky");
      var headerHeight = document.querySelector(".header").offsetHeight;

      if (tableTheadSticky.getBoundingClientRect().top <= headerHeight) {
        theadSticky.classList.add("stl-thead-sticky");
        theadSticky.style.top = headerHeight + "px";

        var tableResponsive = tableTheadSticky.closest(".table-responsive");
        if (tableResponsive) {
          tableResponsive.classList.add("table-responsive-clip");
        }
      } else {
        theadSticky.classList.remove("stl-thead-sticky");
        theadSticky.style.top = "0";
      }
    },
    showComment(item) {
      this.commentActual = [];
      this.commentActual.ID = item.ID;
      this.commentActual.UF_COMMENTS = ""; //item.UF_COMMENTS;
      this.commentActual.UF_NAME = item.UF_NAME;
      this.showCommentDialog = true;
    },
    setCommentAdminType(id, comment) {
      AdminService.setCommentAdminDocument(id, {
        UF_COMMENTS: comment
      }).then(({ data }) => {
        if (!data.error) {
          this.showCommentDialog = false;
          this.fetchList();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      });
    },
    gotoToNewPage(type) {
      if (this.filter.type !== type) {
        this.filter.type = type;
        this.$router.push({
          name: "AdminStatuses",
          params: { type: type }
        });
        this.fetchList();
      }
    },
    onAddNewDoc() {
      this.saveErrorFields = [];
      AdminService.onAddNewDoc(this.newDocType)
        .then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });

              this.saveErrorFields.push({"FILED":text.TEXT});
              //this.saveErrorFields[text.FIELD] = err.TEXT;
              Vue.set(this.saveErrorFields, `${text.FIELD}`, `${text.TEXT}`);

            }, this);

          } else {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
             this.newDocType = {};
             this.showCreateNewQuestion = false;
             this.fetchList();
          }
        })
        .catch(() => {
          this.addError = "Ошибка создания документа";
        });
      return false;
    },
    clearForm() {
      this.showCreateNewQuestion = false;
      this.newDocType = {};
    },
    allRazdelEs() {
      let arr = [];
      let ignoreCodeRazdel = ["letter", "dop_user", "result_expert_rfrp", "result_expert", "expert_zapros", "reg_fond_expert_sovet",
        "reshenie_expert_sovet_frp", "reshenie_supervisory_sovet_frp", 'inginiring'];

      arr.push({ "NAME": "-Укажите раздел-", "SECTION_ID": 0,  });
      Object.keys(this.allTypeList).forEach(key => {
        if (!ignoreCodeRazdel.includes(this.allTypeList[key].CODE)) {
          arr.push({ "NAME": this.allTypeList[key].NAME, "SECTION_ID": this.allTypeList[key].ID });

          if (this.allTypeList[key].CHILD && this.allTypeList[key].CHILD.length > 0) {
            Object.keys(this.allTypeList[key].CHILD).forEach(key2 => {
                arr.push({ "NAME": this.allTypeList[key].CHILD[key2].NAME, "SECTION_ID": this.allTypeList[key].CHILD[key2].ID });

            });
          }

        }
      });
      return arr;
    },
    allRazdelDz() {
      let arr = [];
      let ignoreCodeRazdel = ["letter", 'suspension_conditions'];

      arr.push({ "NAME": "-Укажите раздел-", "SECTION_ID": 0 });
      Object.keys(this.allTypeListDz).forEach(key => {
        if (!ignoreCodeRazdel.includes(this.allTypeListDz[key].CODE)) {
          arr.push({ "NAME": this.allTypeListDz[key].NAME, "SECTION_ID": this.allTypeListDz[key].ID });

          if (this.allTypeListDz[key].CHILD && this.allTypeListDz[key].CHILD.length > 0) {
            Object.keys(this.allTypeListDz[key].CHILD).forEach(key2 => {
              arr.push({ "NAME": this.allTypeListDz[key].CHILD[key2].NAME, "SECTION_ID": this.allTypeListDz[key].CHILD[key2].ID });

            });
          }

        }
      });
      return arr;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkErrorField(field) {
      if (typeof this.saveErrorFields[field] === "undefined") {
        return false;
      }
      return true;
    },
    removeError(field) {
      if (typeof this.saveErrorFields[field] === "undefined") {
        return "";
      }else{
        delete  this.saveErrorFields[field];
      }

      this.addError = "";
      Vue.delete(this.saveErrorFields, field);
    },
    getRandomInt() {
      let rand =Math.floor(Math.random() * 10001);
      return rand
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
